import React, { Component } from 'react';
import { Button } from '@blueprintjs/core';
import ReactSelectAsyncContainer from '../../reactSelectWrappers/ReactSelectAsyncContainer';

class PMProjectSearch extends Component {

	render() {
		const p = this.props;
		return (
			<div>
				<span>Project</span>
				<ReactSelectAsyncContainer
					queryName={'PM.SearchProjects'}
					attr={'Phrase'}
					typeName={'Phrase'}
					focus={true}
					querySearch={false}
					minimumAttributeLength={2}
					onChange={p.selectProjectFromSearch}
					returnObj={{ attr: 'display' }}
				/>
			</div>
		);
	}
}
export default PMProjectSearch;


// WEBPACK FOOTER //
// ./src/components/projectmanager/new/PMProjectSearch.js